'use strict';

document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('[data-hero-slider]').forEach((root) => {
    const slider = root.querySelector('.hero__slider');

    if (!slider || slider.dataset.heroSliderInitialized === 'true') {
      return;
    }

    const slides = slider.querySelectorAll('.swiper-slide');

    if (slides.length <= 1) {
      return;
    }

    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = Number.parseInt(root.dataset.autoplayDelay, 10) || 5000;
    const pagination = slider.querySelector('.hero__pagination');

    slider.dataset.heroSliderInitialized = 'true';

    new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      speed: 650,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
          }
        : false,
    });
  });
});
